module.exports = __webpack_public_path__ + "img/stickers-releves-comptes-x3.e4764819.jpg";